<template>
  <div class="feedback sides-padding">
    <div id="callback" class="container">
      <div class="feedback__inner">
        <h2 class="feedback__title">Возникли вопросы?</h2>
        <span class="feedback__subtitle"
          >Напиши нам и мы ответим на все интересующие вопросы</span
        >
        <form @submit.prevent="submit" class="feedback__form">
          <TextareaComponent
            v-model="form.question.value"
            :error="form.question.error"
            placeholder="Вопрос*"
          />
          <InputComponent
            v-model="form.title.value"
            :error="form.title.error"
            placeholder="Имя*"
          />
          <InputComponent
            v-model="form.email.value"
            :error="form.email.error"
            placeholder="Email"
          />
          <InputComponent
            v-model="form.phone.value"
            :error="form.phone.error"
            placeholder="Телефон*"
            mask="+7 (###) ### - ## - ##"
            is-phone
          />
          <button
            type="submit"
            class="btn btn--md btn--main"
            :disabled="!form.checkbox"
          >
            <FileIconComponent v-if="loading" name="loading" />
            <template v-else>Отправить</template>
          </button>
        </form>
        <TermsAgreeCheckboxComponent
          :checked="form.checkbox"
          @change="form.checkbox = !form.checkbox"
        />
      </div>
    </div>
  </div>
</template>

<script>
import InputComponent from "components/inputs/InputComponent.vue";
import TermsAgreeCheckboxComponent from "components/TermsAgreeCheckboxComponent.vue";
import FileIconComponent from "components/FileIconComponent.vue";
import TextareaComponent from "components/inputs/TextareaComponent.vue";
import AlertModal from "components/modals/components/AlertModal.vue";
import CALLBACK_CREATE from "@/graphql/mutations/CallbackCreate.graphql";

export default {
  name: "CallbackComponent",
  data() {
    return {
      loading: false,
      form: {
        title: {
          value: undefined,
          message: undefined,
          error: undefined,
        },
        email: {
          value: undefined,
          message: undefined,
          error: undefined,
        },
        phone: {
          value: undefined,
          message: undefined,
          error: undefined,
        },
        question: {
          value: undefined,
          message: undefined,
          error: undefined,
        },
        checkbox: false,
      },
    };
  },
  methods: {
    showAlertModal(options) {
      this.$store.state._modals.push({
        component: AlertModal,
        options: options,
      });
    },
    submit() {
      if (!this.loading) {
        this.loading = true;
        this.resetErrors("form");
        this.$apollo.provider.defaultClient
          .mutate({
            mutation: CALLBACK_CREATE,
            variables: {
              title: this.form.title.value,
              email: this.form.email.value,
              phone: this.form.phone.value,
              question: this.form.question.value,
            },
            context: {
              headers: {
                Authorization: "Bearer " + this.$store.state.apollo_token,
              },
            },
          })
          .then(({ data }) => {
            this.loading = false;
            this.resetForm("form");
            if (data && data.CallbackCreate) {
              this.showAlertModal({
                title: "Возникли вопросы?",
                message: data.CallbackCreate.message,
              });
            }
          })
          .catch(({ graphQLErrors }) => {
            this.loading = false;
            this.parseGqlErrors(graphQLErrors);
          });
      }
    },
    resetForm(form) {
      Object.keys(this[form]).forEach((key) => {
        this[form][key].value = undefined;
      });
    },
    resetErrors(form) {
      Object.keys(this[form]).forEach((key) => {
        this[form][key].error = undefined;
      });
    },
    parseGqlErrors(graphQLErrors) {
      graphQLErrors.forEach((err) => {
        if (err.extensions.category === "validation") {
          Object.keys(err.extensions.validation).forEach((key) => {
            if (this.form[key]) {
              this.form[key].error = err.extensions.validation[key][0];
            }
          });
        }
      });
    },
  },
  components: {
    TextareaComponent,
    FileIconComponent,
    TermsAgreeCheckboxComponent,
    InputComponent,
  },
};
</script>

<style lang="stylus">
.feedback {
  position relative
  background var(--gray)
  overflow hidden
	color: var(--main-color)

  &__inner {
    position relative
    z-index 1
    display flex
    flex-direction column
    align-items center
    padding 94px 0
    +below(840px) {
      padding 32px 0 40px
    }
  }

  &__title {
    +below(840px) {
      margin-bottom: 15px;
    }
  }

  &__subtitle {
    text-align center
  }

  &:before,
  &:after {
    content ""
    display block
    width: 590px
    height: 590px
    background: radial-gradient(50% 50% at 50% 50%, var(--white) 0%, rgba(255, 255, 255, 0) 100%);
    position absolute
    pointer-events none
  }

  &:before {
    left: -254px
    top 0
  }

  &:after {
    right -222px
    bottom 0
  }

  &__form {
    width 100%
    margin-top: 30px;
    display grid
    grid-template-columns repeat(4, 1fr)
    grid-gap 20px
    +below(860px) {
      grid-template-columns 1fr
      max-width 450px
    }

    .input {
      &__field {
        font-size 1em
      }

      &__container {
        border-color var(--main-color-75)
      }
    }

    .textarea {
      +above(861px) {
        grid-column: auto / span 4;
      }
    }
  }

  .terms__agree {
    margin-top: 20px;
  }
}
</style>
